import { DependencyList, EffectCallback, useRef } from 'react';
import { ArrayUtils } from 'record-it-utils/utils/ArrayUtils/ArrayUtils';

/**
 * Sometimes we need an effect style api which runs while rerendering.
 * This is necessary for integrating external libraries or also if you need to calculate some derived value.
 * A drawback of this is, that you can't use the setter methods of useState
 */
export function useEffectSync(effect: EffectCallback, deps: DependencyList): void {
  const lastCallInfo = useRef<{
    destructor: ReturnType<EffectCallback>;
    deps: DependencyList;
  } | null>(null);
  if (lastCallInfo.current == null || !ArrayUtils.areShallowEqual(lastCallInfo.current.deps, deps)) {
    const destructor = lastCallInfo.current?.destructor;
    if (destructor instanceof Function) {
      destructor();
    }
    lastCallInfo.current = {
      destructor: effect(),
      deps
    };
  }
}